import { render, staticRenderFns } from "./SedesPresupuestos.vue?vue&type=template&id=6f3a3956&scoped=true"
import script from "./SedesPresupuestos.vue?vue&type=script&lang=js"
export * from "./SedesPresupuestos.vue?vue&type=script&lang=js"
import style0 from "./SedesPresupuestos.vue?vue&type=style&index=0&id=6f3a3956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a3956",
  null
  
)

export default component.exports